import { useEffect } from "react";
import { useContactDirectoryStore } from "stores/useContactDirectoryStore";

// People to suggest in guest and recipient pickers. Starts empty and fills in
// once the directory loads; pickers keep working on team options until then.
export default function useContactDirectory() {
  const contacts = useContactDirectoryStore((state) => state.contacts);
  const load = useContactDirectoryStore((state) => state.load);

  useEffect(() => {
    load();
  }, [load]);

  return contacts;
}
